import React, { useEffect, useState } from 'react';
import AccountCard from '../components/AccountCard';
import { fetchMetaAccounts, disconnectMeta } from '../api/meta';
import { useToast } from '../hooks/useToast';

export default function Accounts() {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { notify } = useToast();

  const loadAccounts = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await fetchMetaAccounts();
      setAccounts(data.accounts || []);
    } catch (err) {
      setError(err.message || 'Failed to load accounts');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAccounts();
  }, []);

  const handleDisconnect = async () => {
    try {
      await disconnectMeta();
      notify('Meta accounts disconnected');
      loadAccounts();
    } catch (err) {
      notify(err.message || 'Failed to disconnect');
    }
  };

  return (
    <section className="panel">
      <div className="panel-header">
        <h2>Connected Accounts</h2>
        <button className="secondary" onClick={handleDisconnect}>Disconnect</button>
      </div>

      {loading ? <p>Loading accounts...</p> : null}
      {error ? <p className="error">{error}</p> : null}
      {!loading && !error && accounts.length === 0 ? (
        <p>No connected accounts yet.</p>
      ) : null}
      <div className="card-grid">
        {accounts.map((account) => (
          <AccountCard key={account.page_id || account.ig_id} account={account} />
        ))}
      </div>
    </section>
  );
}
